<ejs-richtexteditor id='defaultRTE' [formControlName]="formControlName">
</ejs-richtexteditor>
